import router from "@/router";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const getTaxDate = taxDay => {
  let today = new Date();
  today.setHours(0, 0, 0, 0);

  let currentYear = today.getFullYear();

  if (today >= new Date(`${currentYear}-${taxDay}T00:00:00Z`)) {
    return new Date(`${currentYear}-${taxDay}T00:00:00Z`);
  } else {
    return new Date(`${currentYear - 1}-${taxDay}T00:00:00Z`);
  }
};

const state = {
  user: null,
  settings: null
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserSettingsToStore(state, settings) {
    state.settings = settings;
  }
};

const actions = {
  registerUser({ commit, dispatch }, payload) {
    commit("setLoading", true);
    commit("clearError");
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(user => {
        dispatch("setDefaultSettingsForNewUser", { userId: user.user.uid });
        const newbie = firebase.auth().currentUser;
        newbie
          .updateProfile({
            displayName: payload.name
          })
          .then(() => {
            commit("setLoading", false);
            const newUser = {
              id: user.user.uid,
              name: payload.name
            };
            commit("setUser", newUser);
          })
          .catch(error => {
            commit("setLoading", false);
            commit("setError", error);
            console.log(error);
          });
      })
      .catch(error => {
        commit("setError", error);
        commit("setLoading", false);
        console.log(error);
      });
  },
  signInUser({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");
    firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then(user => {
        commit("setLoading", false);
        const signedUser = {
          id: user.user.uid,
          name: user.user.displayName
        };
        commit("setUser", signedUser);
      })
      .catch(error => {
        commit("setError", error);
        commit("setLoading", false);
        console.log(error);
      });
  },
  autoSignIn({ commit }, payload) {
    commit("setLoading", true);
    const signedUser = {
      id: payload.uid,
      name: payload.displayName
    };
    commit("setUser", signedUser);
  },
  signOut({ commit }) {
    firebase.auth().signOut();
    commit("setUser", null);
    commit("resetAllTransactions");
    router.push("login");
  },
  setDefaultSettingsForNewUser({ commit }, payload) {
    let settings = {
      taxDay: "04-06" // this is default UK tax day => {month}-{day}
    };

    firebase
      .database()
      .ref("users/" + payload.userId + "/settings")
      .push(settings)
      .then(() => {
        commit("setUserSettingsToStore", settings);
      });
  },
  getUserSettings({ commit, dispatch }, payload) {
    firebase
      .database()
      .ref("users/" + payload.userId + "/settings")
      .on("child_added", data => {
        console.log(data.val());
        let settings = {
          settingsId: data.key,
          userId: payload.userId,
          taxDay: data.val().taxDay,
          taxDate: getTaxDate(data.val().taxDay).toISOString()
        };
        commit("setUserSettingsToStore", settings);
        dispatch("getTransactions", settings);
      });
  },
  setNewTaxDay({ commit, dispatch }, payload) {
    commit("setLoading", true);
    commit("clearError");

    firebase
      .database()
      .ref("users/" + payload.userId + "/settings")
      .child(payload.id)
      .update({ taxDay: payload.taxDay })
      .then(() => {
        let settings = {
          settingsId: payload.id,
          userId: payload.userId,
          taxDay: payload.taxDay,
          taxDate: getTaxDate(payload.taxDay).toISOString()
        };

        commit("setUserSettingsToStore", settings);
        commit("resetAllTransactions");
        dispatch("getTransactions", settings);
      })
      .catch(error => {
        commit("setError", error);
        commit("setLoading", false);
        console.log(error);
      });
  }
};

const getters = {
  user(state) {
    return state.user;
  },
  settings(state) {
    return state.settings;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
